{
  "market": {
    "common": {
      "conditions": {
        "new": "Novo",
        "used": "Usado",
        "refurbished": "Recondicionado"
      },
      "status": {
        "draft": "Rascunho",
        "published": "Publicada",
        "publishedProduct": "Publicado",
        "disabled": "Desativada",
        "disabledProduct": "Desativado",
        "archived": "Arquivada",
        "archivedProduct": "Arquivado"
      },
      "sessionExpired": "Sessão expirada.",
      "sessionExpiredReconnect": "Sessão expirada — inicie sessão novamente.",
      "sessionExpiredReconnect2": "Sessão expirada. Inicie sessão novamente.",
      "networkError": "Problema de conexão. Tente novamente.",
      "cannotLoad": "Não é possível carregar.",
      "retry": "Tentar novamente",
      "loading": "Carregando…",
      "back": "Voltar",
      "cancel": "Cancelar",
      "save": "Guardar",
      "saving": "Guardando…",
      "copy": "Copiar link",
      "copied": "Copiado!",
      "seeMore": "Ver mais",
      "offlineText": "Sem conexão com a internet"
    },
    "boutiques": {
      "searchPlaceholder": "Pesquisar…",
      "headerCount_one": "{{count}} loja",
      "headerCount_other": "{{count}} lojas",
      "loadingNormal": "Procurando as melhores lojas…",
      "loadingSearch": "Pesquisando…",
      "errorNormal": "Não foi possível carregar as lojas no momento.",
      "errorSearch": "Não foi possível iniciar a pesquisa.",
      "emptyNormal": "Nenhuma loja publicada até o momento.",
      "emptySearch": "Nenhuma loja corresponde a esta pesquisa.",
      "online": "On-line",
      "productsCount_one": "{{count}} produto",
      "productsCount_other": "{{count}} produtos",
      "subscribersCount_one": "{{count}} assinante",
      "subscribersCount_other": "{{count}} assinantes",
      "visit": "Visitar"
    },
    "creerBoutique": {
      "headerTitle": "Nova loja",
      "subtitle": "Dê um nome à sua loja. Você poderá personalizar sua aparência e adicionar produtos logo em seguida.",
      "nameLabel": "Nome da loja",
      "namePlaceholder": "Ex.: Ateliê Wax & Co",
      "submit": "Criar loja"
    },
    "creerProduit": {
      "headerTitle": "Novo produto",
      "createButton": "Criar",
      "intro": "Preencha a ficha do seu produto agora. Os campos marcados com um asterisco são obrigatórios — o resto pode ser completado ou alterado mais tarde.",
      "sections": {
        "essential": "Essencial",
        "details": "Detalhes",
        "advanced": "Opções avançadas",
        "advancedSubtitle": "Preço promocional, moeda, destaque, botões de ação",
        "seo": "SEO",
        "seoSubtitle": "Como este produto aparece nos resultados de pesquisa e ao ser compartilhado"
      },
      "fields": {
        "nameLabel": "Nome do produto *",
        "namePlaceholder": "Ex.: Colar de contas wax",
        "priceLabel": "Preço ({{currency}}) *",
        "pricePlaceholder": "Ex.: 8000",
        "categoryLabel": "Categoria",
        "categoryPlaceholder": "Deixe em branco para «Outro»",
        "categoryHint": "Identificador da categoria — em breve um seletor substituirá este campo.",
        "descriptionShortLabel": "Descrição curta",
        "descriptionShortPlaceholder": "Uma frase que desperte interesse",
        "descriptionLabel": "Descrição completa",
        "descriptionPlaceholder": "Detalhe as características, materiais, dimensões…",
        "brandLabel": "Marca",
        "brandPlaceholder": "Ex.: Feito à mão, Nike…",
        "conditionLabel": "Estado",
        "stockLabel": "Estoque disponível",
        "stockPlaceholder": "Ex.: 12",
        "stockHint": "Deixe em branco para começar em 0.",
        "skuLabel": "Referência (SKU)",
        "skuPlaceholder": "Ex.: COL-WAX-001",
        "skuHint": "Deve ser único nesta loja, se informado.",
        "promoPriceLabel": "Preço promocional",
        "promoPricePlaceholder": "Deve ser menor ou igual ao preço normal",
        "currencyLabel": "Moeda",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Código ISO de 3 letras (XOF, EUR, USD…).",
        "featuredLabel": "Destacar este produto",
        "seoTitleLabel": "Título SEO",
        "seoTitlePlaceholder": "Título exibido nos resultados de pesquisa",
        "seoDescriptionLabel": "Descrição SEO",
        "seoDescriptionPlaceholder": "Resumo exibido abaixo do título nas pesquisas"
      },
      "actionButtons": {
        "groupLabel": "Botões de ação",
        "whatsapp": "Botão de WhatsApp dedicado",
        "whatsappField": "Número de WhatsApp exibido apenas para este produto",
        "whatsappPlaceholder": "Ex.: +225 07 00 00 00 00",
        "buy": "Botão \"Comprar\"",
        "buyField": "Link para a página ou pagamento",
        "learnMore": "Botão \"Saiba mais\"",
        "learnMoreField": "Link para mais detalhes",
        "call": "Botão \"Ligar\"",
        "callField": "Número para ligar sobre este produto"
      },
      "preview": {
        "label": "Pré-visualização",
        "namePlaceholder": "Nome do produto",
        "promoLabel": "Preço promocional: {{price}}",
        "featuredBadge": "Em destaque",
        "hint": "Foto, ambiente e layout reais disponíveis logo após a criação."
      }
    },
    "index": {
      "searchPlaceholder": "Pesquisar…",
      "headerCount_one": "{{count}} produto",
      "headerCount_other": "{{count}} produtos",
      "loadingNormal": "Carregando o mercado…",
      "loadingSearch": "Pesquisando…",
      "errorNormal": "Não foi possível carregar o mercado.",
      "errorSearch": "Não foi possível iniciar a pesquisa.",
      "emptyNormal": "Nenhum produto publicado até o momento.",
      "emptySearch": "Nenhum produto corresponde a esta pesquisa.",
      "newBadge": "Novo",
      "whatsapp": "WhatsApp",
      "contact": "Contatar",
      "contacting": "Abrindo…",
      "buy": "Comprar",
      "learnMore": "Saiba mais",
      "call": "Ligar",
      "seeMore": "Ver mais",
      "goToShop": "Ir para a loja",
      "whatsappMessage": "Olá, tenho interesse em \"{{product}}\" no Harmonia Market."
    },
    "reglages": {
      "headerTitle": "Configurações",
      "headerSubPro": "Gerencie suas lojas, favoritos e assinaturas",
      "headerSubStandard": "Seus favoritos e lojas seguidas",
      "sections": {
        "subscribedShops": "Lojas seguidas",
        "favorites": "Favoritos",
        "myShops": "Minhas lojas"
      },
      "noSubscribedShops": "Você ainda não segue nenhuma loja.",
      "noFavorites": "Nenhum produto salvo até o momento.",
      "noMyShops": "Você ainda não tem uma loja.",
      "productsCount_one": "{{count}} produto",
      "productsCount_other": "{{count}} produtos",
      "createShopButton": "Criar uma nova loja"
    },
    "gererShop": {
      "notFound": "Loja não encontrada.",
      "sections": {
        "coverPhoto": "Foto de capa",
        "publicLink": "Link público",
        "generalInfo": "Informações gerais",
        "contacts": "Contatos",
        "location": "Localização",
        "seo": "SEO",
        "status": "Status da loja",
        "colors": "Cores",
        "typography": "Tipografia, layout, cabeçalho",
        "products": "Produtos",
        "dangerZone": "Zona de perigo"
      },
      "colorFields": {
        "primary": "Cor principal",
        "secondary": "Cor secundária",
        "accent": "Cor de destaque",
        "background": "Cor de fundo",
        "card": "Cor dos cartões",
        "button": "Cor dos botões",
        "border": "Cor das bordas",
        "text": "Cor do texto",
        "link": "Cor dos links"
      },
      "publicLinkHint": "Esta página é visível para todos, inclusive pessoas não conectadas. Compartilhe este link para divulgar sua loja.",
      "publicLinkPending": "O link ficará disponível assim que a loja for salva.",
      "saveError": "Falha ao salvar — tente novamente.",
      "fields": {
        "taglineLabel": "Slogan",
        "taglinePlaceholder": "Uma frase que resuma sua loja",
        "taglineHint": "Máx. 160 caracteres.",
        "descriptionLabel": "Descrição",
        "descriptionPlaceholder": "Apresente sua loja em detalhes",
        "whatsappLabel": "Número do WhatsApp Business",
        "whatsappPlaceholder": "Ex.: +225 07 00 00 00 00",
        "whatsappHint": "Obrigatório se o botão do WhatsApp estiver ativado abaixo.",
        "showWhatsappBtn": "Exibir o botão do WhatsApp",
        "showChatBtn": "Exibir o chat da plataforma",
        "contactEmailLabel": "E-mail de contato",
        "contactEmailPlaceholder": "contato@minhaloja.com",
        "contactPhoneLabel": "Telefone de contato",
        "contactPhonePlaceholder": "Ex.: +225 07 00 00 00 00",
        "countryLabel": "País",
        "countryPlaceholder": "Ex.: Costa do Marfim",
        "cityLabel": "Cidade",
        "cityPlaceholder": "Ex.: Abidjan",
        "addressLabel": "Endereço",
        "addressPlaceholder": "Endereço completo",
        "currencyLabel": "Moeda",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Código ISO de 3 letras maiúsculas (XOF, EUR, USD…).",
        "languageLabel": "Idioma",
        "timezoneLabel": "Fuso horário",
        "timezonePlaceholder": "Ex.: Africa/Abidjan",
        "seoTitleLabel": "Título SEO",
        "seoTitlePlaceholder": "Título exibido nos resultados de pesquisa",
        "seoDescriptionLabel": "Descrição SEO",
        "seoDescriptionPlaceholder": "Resumo exibido abaixo do título nas pesquisas"
      },
      "statusHint": "Uma loja «Publicada» fica visível publicamente, inclusive para pessoas não conectadas.",
      "typographyPending": "Essas configurações chegarão em uma próxima etapa.",
      "noProducts": "Nenhum produto até o momento.",
      "cannotLoadProducts": "Não foi possível carregar os produtos.",
      "createProductButton": "Criar um produto",
      "dangerTitle": "Excluir esta loja",
      "dangerText": "Esta ação é definitiva. Todos os produtos desta loja serão excluídos junto com ela.",
      "dangerButton": "Excluir a loja",
      "deleteModal": {
        "title": "Excluir «{{name}}»?",
        "text": "Esta ação é irreversível. Todos os produtos desta loja ({{count}}) serão excluídos definitivamente junto com ela.",
        "confirmLabel": "Para confirmar, digite o nome exato da loja:",
        "confirmButton": "Excluir definitivamente"
      }
    },
    "gererProduit": {
      "notFound": "Produto não encontrado.",
      "saveButton": "Guardar",
      "savedBanner": "Alterações salvas",
      "saveError": "Falha ao salvar — tente novamente.",
      "sections": {
        "publicLink": "Link público",
        "photos": "Fotos",
        "essential": "Essencial",
        "details": "Detalhes",
        "advanced": "Opções avançadas",
        "seo": "SEO",
        "dangerZone": "Zona de perigo"
      },
      "publicLinkHint": "Esta página é visível para todos, inclusive pessoas não conectadas. Compartilhe este link para divulgar este produto.",
      "publicLinkPending": "O link ficará disponível assim que o produto for salvo.",
      "fields": {
        "mainPhoto": "Foto principal",
        "photo2": "Foto 2",
        "photo3": "Foto 3",
        "photo3Hint": "A foto 3 requer que a foto 2 já esteja preenchida.",
        "nameLabel": "Nome do produto *",
        "namePlaceholder": "Ex.: Colar de contas wax",
        "priceLabel": "Preço ({{currency}}) *",
        "pricePlaceholder": "Ex.: 8000",
        "categoryLabel": "Categoria",
        "statusLabel": "Status",
        "descriptionShortLabel": "Descrição curta",
        "descriptionShortPlaceholder": "Uma frase que desperte interesse",
        "descriptionLabel": "Descrição completa",
        "descriptionPlaceholder": "Detalhe as características…",
        "brandLabel": "Marca",
        "brandPlaceholder": "Ex.: Feito à mão, Nike…",
        "conditionLabel": "Estado",
        "stockLabel": "Estoque disponível",
        "stockPlaceholder": "Ex.: 12",
        "promoPriceLabel": "Preço promocional",
        "promoPricePlaceholder": "Deve ser ≤ ao preço normal",
        "currencyLabel": "Moeda",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Código ISO de 3 letras.",
        "featuredLabel": "Destacar este produto",
        "showChatLabel": "Exibir o chat da plataforma",
        "seoTitleLabel": "Título SEO",
        "seoTitlePlaceholder": "Título exibido nos resultados de pesquisa",
        "seoDescriptionLabel": "Descrição SEO",
        "seoDescriptionPlaceholder": "Resumo exibido abaixo do título"
      },
      "actionButtons": {
        "groupLabel": "Botões de ação",
        "whatsapp": "Botão de WhatsApp dedicado",
        "whatsappHint": "Número específico para este produto.",
        "whatsappPlaceholder": "Ex.: +225 07 00 00 00 00",
        "buy": "Botão \"Comprar\"",
        "learnMore": "Botão \"Saiba mais\"",
        "call": "Botão \"Ligar\"",
        "callPlaceholder": "Ex.: +225 07 00 00 00 00"
      },
      "dangerTitle": "Excluir este produto",
      "dangerText": "Esta ação é definitiva e não pode ser desfeita.",
      "dangerButton": "Excluir o produto",
      "deleteModal": {
        "title": "Excluir «{{name}}»?",
        "text": "Esta ação é irreversível.",
        "confirmButton": "Excluir"
      }
    },
    "components": {
      "categoryChips": {
        "loading": "Carregando categorias…",
        "error": "Não foi possível carregar as categorias.",
        "allLabel": "Todas"
      },
      "colorPicker": {
        "cancel": "Cancelar",
        "confirm": "Confirmar"
      },
      "detailProduit": {
        "newBadge": "Novo",
        "inStock": "Em estoque ({{count}})",
        "outOfStock": "Sem estoque",
        "descriptionTitle": "Descrição",
        "whatsapp": "Contatar via WhatsApp",
        "contactSeller": "Contatar o vendedor",
        "contacting": "Abrindo…",
        "buy": "Comprar",
        "learnMore": "Saiba mais",
        "call": "Ligar",
        "goToShop": "Ir para a loja",
        "whatsappMessage": "Olá, tenho interesse em \"{{product}}\" no Harmonia Market."
      },
      "searchBar": {
        "placeholder": "Pesquisar…"
      },
      "shopHeader": {
        "productsLabel": "Produtos",
        "subscribersLabel": "Assinantes",
        "subscribed": "Seguindo",
        "subscribe": "Seguir",
        "subscribing": "…"
      },
      "imagePicker": {
        "change": "Alterar",
        "add": "Adicionar uma imagem",
        "sessionExpired": "Sessão expirada.",
        "uploadError": "Falha no envio."
      }
    },
    "produitDetail": {
      "loading": "Carregando o produto…",
      "notFound": "Este produto não existe ou não está mais disponível.",
      "cannotLoad": "Não foi possível carregar este produto."
    },
    "boutiqueDetail": {
      "loading": "Carregando a loja…",
      "notFound": "Esta loja não existe ou não está mais disponível.",
      "cannotLoad": "Não foi possível carregar esta loja.",
      "shopNotFound": "Loja não encontrada.",
      "newBadge": "Novo",
      "productsTitle": "Produtos",
      "cannotLoadProducts": "Não foi possível carregar os produtos.",
      "noProducts": "Nenhum produto publicado até o momento."
    }
  }
}
